import { render, staticRenderFns } from "./ScopeDialog.vue?vue&type=template&id=60d67755&scoped=true"
import script from "./ScopeDialog.vue?vue&type=script&lang=js"
export * from "./ScopeDialog.vue?vue&type=script&lang=js"
import style0 from "./ScopeDialog.vue?vue&type=style&index=0&id=60d67755&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d67755",
  null
  
)

export default component.exports